<template>
	<Modal @close="$emit('close')" size="small">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<h3>Edit Item</h3>
				</div>
			</div>
			<Form :equipment="equipment" @close="$emit('close')"/>
		</div>
	</Modal>
</template>

<script>
import Modal from './../Modal.vue'
import Form from './Form.vue'

export default {
	components: {
		Modal,
		Form
	},
	props: [
		'equipment'
	]
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Equipment/Edit.vue